import { z } from "zod";
export const McpAuthorizeRequestSchema = z.object({
    clientId: z.string().min(1),
    redirectUri: z.string().url(),
    state: z.string().min(1).optional(),
    codeChallenge: z.string().min(1),
    codeChallengeMethod: z.literal("S256"),
    resource: z.string().url(),
});
//# sourceMappingURL=mcp.types.js.map